import request from "@/utils/request";

const api = {
  GetSsoHost: 'sso-host',
  GetLoginUserInfo: 'login-user',
  GetDefaultPasswordRequired: 'getDefaultPasswordRequired',
  GetCurrentWorkbench: "/current-workbench",
  GetCurrentWorkbenchV2: "/current-workbench/v2",
  GetCurrentNavigation: "/current-navigation",
  GetNavigationDetail: "/navigation/detail",
  AppList: "/workbench/current-app",
  AppListV2: "/workbench/current-app/v2",
  AddCommonApp: "/workbench/add-common-app",
  DeleteCommonApp: "/workbench/delete-common-app",
  AddHideApp: "/workbench/add-hide-app",
  DeleteHideApp: "/workbench/delete-hide-app",
  GetEmpContacts: "/contacts/emp"

};

/**
 * 是否强制修改密码
 * @returns {*}
 */
export function getDefaultPasswordRequired() {
  return request({
    url: api.GetDefaultPasswordRequired,
    method: 'get'
  })
}

export function getSsoHost(parameter) {
  return request({
    url: api.GetSsoHost,
    method: "get",
    params: parameter,
  });
}

export function getLoginUserDetail(parameter) {
  return request({
    url: api.GetLoginUserInfo,
    method: "get",
    params: parameter,
  });
}

/** @deprecated 使用 getCurrentWorkbenchV2；保留至 V2 上线验证完成。 */
export function getCurrentWorkbench(parameter) {
  return request({
    url: api.GetCurrentWorkbench,
    method: "get",
    params: parameter,
  });
}

export function getCurrentWorkbenchV2(parameter) {
  return request({
    url: api.GetCurrentWorkbenchV2,
    method: "get",
    params: parameter,
  });
}

export function getCurrentNavigation(parameter) {
  return request({
    url: api.GetCurrentNavigation,
    method: "get",
    params: parameter,
  });
}

export function getNavigationDetail(parameter) {
  return request({
    url: api.GetNavigationDetail,
    method: "get",
    params: parameter,
  });
}

/** @deprecated 使用 getAppListV2；保留至 V2 上线验证完成。 */
export function getAppList(parameter) {
  return request({
    url: api.AppList,
    method: "get",
    params: parameter,
  });
}

export function getAppListV2(parameter) {
  return request({
    url: api.AppListV2,
    method: "get",
    params: parameter,
  });
}

export function addCommonApp(parameter) {
  return request({
    url: api.AddCommonApp,
    method: "post",
    params: parameter,
  });
}

export function deleteCommonApp(parameter) {
  return request({
    url: api.DeleteCommonApp,
    method: "post",
    params: parameter,
  });
}

export function addHideApp(parameter) {
  return request({
    url: api.AddHideApp,
    method: "post",
    params: parameter,
  });
}

export function deleteHideApp(parameter) {
  return request({
    url: api.DeleteHideApp,
    method: "post",
    params: parameter,
  });
}

export function getEmpContacts(parameter) {
  return request({
    url: api.GetEmpContacts,
    method: "get",
    params: parameter,
  });
}
